// extracted by mini-css-extract-plugin
export default {"overview":"styles_overview__LwV5I","close":"styles_close__RQeC9","title":"styles_title__U6d5m","description":"styles_description__54WtS"};